module.exports = __webpack_public_path__ + "files/5f58f75014cdf5e3b101a03f6fd6530a.svg";